module.exports = __webpack_public_path__ + "img/p65-xichang-2012.b178ce48.jpg";